import { deleteAnalysis, fetchAnalysisAuditById } from '../state/actions/AnalysisActions';

import AnalysisPriority from '../Analysis/AnalysisPriority';
import { Can } from '../Can';
import DeleteResourceButton from '../DeleteResource';
import { DocumentsList } from '../Document/DocumentsList';
import { Error } from '../shared/Error/Error';
import { AnalysisCard } from '../AnalysisCard/AnalysisCard';
import { History } from '../../helpers';
import { formatDate } from '../../utils/dateUtils';
import { LoadingIndicator } from '../shared/LoadingIndicator/LoadingIndicator';
import PropTypes from 'prop-types';
import React from 'react';
import ReassignAnalysis from '../ReassignAnalysis/ReassignAnalysis';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

export class AnalysisViewer extends React.PureComponent {
    static propTypes = {
        analysisId: PropTypes.string,
        fetchAnalysisAuditById: PropTypes.func,
        fetched: PropTypes.bool.isRequired,
        fetching: PropTypes.bool.isRequired,
        failed: PropTypes.bool,
        analysis: PropTypes.object,
        deleteAnalysis: PropTypes.func.isRequired,
    };

    componentDidMount() {
        const { analysisId, fetchAnalysisAuditById } = this.props;

        fetchAnalysisAuditById(analysisId);
    }

    questionAndAnswerItem = questionId => {
        const { analysis } = this.props;
        const { answers, questions, tags } = analysis;

        const question = questions.find(q => q.id === questionId);
        const answer = answers.find(a => a.questionId === questionId);
        const tag = tags.find(t => t.questionId === questionId);

        return (
            <li key={questionId} className="list-group-item">
                <div className="container">
                    <a id={question.section} />
                    <dl>
                        <dt>Section</dt>
                        <dd>{question.section}</dd>
                        <dt>Title</dt>
                        <dd>{question.title}</dd>
                        <dt>Description</dt>
                        <dd>{question.description}</dd>
                        <dt>Answer:</dt>
                        <dd>{answer.answer.toString()}</dd>
                        <dt>Text Selection:</dt>
                        <dd>{tag.textNotFound ? tag.text : 'Text not found'}</dd>
                    </dl>
                </div>
            </li>
        );
    };

    render() {
        const { failed, fetched, fetching, analysis, analysisId } = this.props;

        if (!fetched && !failed) {
            return <LoadingIndicator busy={fetching} />;
        } else if (failed) {
            return <Error message="Failed to fetch analysis record" />;
        } else if (analysisId && !analysis) {
            return (
                <div>
                    <h3>Analysis not started yet</h3>
                </div>
            );
        } else {
            const { questions, questionLog, vendor, documents, name } = analysis;

            const products = (analysis.products || [analysis.product]).filter(Boolean);

            if (questions) {
                const sections = [...new Set(questions.map(q => q.section))];

                return (
                    <Can I="read" a="ProductAnalysisAudit">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex justify-content-between">
                                    <h4 className="card-title">
                                        {name || 'N/A'}{' '}
                                        <small className="text-muted">
                                            {vendor ? 'Vendor Analysis' : 'Product Analysis'}
                                        </small>
                                    </h4>
                                    <Can I="delete" a="Analysis">
                                        <div className="float-right">
                                            <DeleteResourceButton
                                                resourceId={analysisId}
                                                deleteAction={this.props.deleteAnalysis}
                                                navBack={'/analyses'}
                                            >
                                                Delete Analysis
                                            </DeleteResourceButton>
                                        </div>
                                    </Can>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-sm-9">
                                        {vendor && (
                                            <div className="card">
                                                <div className="card-body">
                                                    <div className="d-flex justify-content-between">
                                                        <h6 className="card-title">
                                                            {vendor.name}
                                                        </h6>
                                                        <div>
                                                            <dl>
                                                                <dt>Website</dt>
                                                                <dd>{vendor.website || 'N/A'}</dd>
                                                                <dt>Updated</dt>
                                                                <dd>
                                                                    {vendor.updated
                                                                        ? formatDate(vendor.updated)
                                                                        : 'N/A'}
                                                                </dd>
                                                            </dl>
                                                            <AnalysisCard
                                                                analysis={vendor.analysis}
                                                            />
                                                            <div className="form-group row d-flex justify-content-end">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-secondary"
                                                                    onClick={() =>
                                                                        History.push('/analyses')
                                                                    }
                                                                >
                                                                    Close
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        <div className="card mt-3">
                                            <h6 className="card-header">Analysis Priority</h6>
                                            <div className="card-body">
                                                <AnalysisPriority {...analysis} />
                                            </div>
                                        </div>
                                        {products.length > 0 && (
                                            <div className="card mt-3">
                                                <h6 className="card-header">
                                                    {vendor ? 'Products' : 'Product'}
                                                </h6>
                                                <div className="card-body">
                                                    <ul className="list-group list-group-flush">
                                                        {products.map(product => (
                                                            <li
                                                                key={product.id}
                                                                className="list-group-item"
                                                            >
                                                                <div className="row">
                                                                    <div className="col-sm">
                                                                        <strong>
                                                                            {product.name}
                                                                        </strong>
                                                                    </div>
                                                                    <div className="col-sm">
                                                                        {product.vendor
                                                                            ? product.vendor.name
                                                                            : 'No vendor'}
                                                                    </div>
                                                                    <div className="col-sm">
                                                                        {product.updated ||
                                                                        product.created
                                                                            ? formatDate(
                                                                                  product.updated ||
                                                                                      product.created
                                                                              )
                                                                            : ''}
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            </div>
                                        )}

                                        <div className="card mt-3">
                                            <h6 className="card-header">Documents</h6>
                                            <div className="card-body">
                                                <DocumentsList
                                                    documents={documents}
                                                    backLink={`/analysis-viewer/${analysisId}`}
                                                />
                                            </div>
                                        </div>

                                        <div className="card mt-3">
                                            <h6 className="card-header">Administrative Review</h6>
                                            <div className="card-body">
                                                <ReassignAnalysis {...analysis} />
                                            </div>
                                        </div>

                                        <div className="card mt-3">
                                            <h6 className="card-header">Questions</h6>
                                            <div className="card-body">
                                                {questionLog ? (
                                                    <ul className="list-group list-group-flush">
                                                        {questionLog.map(qId =>
                                                            this.questionAndAnswerItem(qId)
                                                        )}
                                                    </ul>
                                                ) : (
                                                    <div className="container">
                                                        <div className="row">
                                                            <div className="col-sm">
                                                                No questions have been answered.
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-3 p-3">
                                        <div className="card">
                                            <h6 className="card-header">Analysis Sections</h6>
                                            <ul className="list-group list-group-flush mb-2">
                                                {sections.map(section => (
                                                    <li key={section} className="list-group-item">
                                                        <a href={`#${section}`}>{section}</a>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Can>
                );
            } else {
                return <Error message="Analysis not started yet" />;
            }
        }
    }
}

// CONFIGURE REACT REDUX
const mapStateToProps = state => state.analysis;

const mapDispatchToProps = dispatch =>
    bindActionCreators({ fetchAnalysisAuditById, deleteAnalysis }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AnalysisViewer);
